import React from "react";

const ValueDevelopmentSection: React.FC = () => {
  return (
    <div className="space-y-3">
      <h3 className="text-base font-semibold text-gray-900 font-serif">
        Wertentwicklung
      </h3>
      <div className="w-full h-40 bg-gray-50 rounded flex items-end justify-between px-4 py-4 gap-2 filter blur-sm opacity-50 select-none pointer-events-none">
        {/* Mock Chart Bars */}
        <div className="w-full bg-gray-200 rounded-t h-[40%]"></div>
        <div className="w-full bg-gray-300 rounded-t h-[55%]"></div>
        <div className="w-full bg-prime-200 rounded-t h-[70%]"></div>
        <div className="w-full bg-prime-400 rounded-t h-[85%]"></div>
        <div className="w-full bg-prime-600 rounded-t h-[100%]"></div>
      </div>
    </div>
  );
};

export default ValueDevelopmentSection;
